<template>
  <vue100vh style="position: fixed; width: 100%; overflow-y: hidden !important;">
  <div style="overflow-y: hidden !important;" class="leftbox">
    <v-tabs slot="extension" v-model="tabs" fixed-tabs color="#2562af" icons-and-text centered
    style="position: fixed; bottom: 0; width: 100%; z-index: 1;">
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" :key="1" @click="toTab(1)">
        <span style="color: white; text-transform: none;">{{$t('LeftSide.header.homepage')}}</span>
        <v-badge v-model="show" color="red" v-if="(num_groupreq + num_friendsendreq + num_friendreq) !== 0">
        <span slot="badge">{{num_groupreq + num_friendsendreq + num_friendreq}}</span>
        <v-icon style="font-size: 22px !important;color: #ffffff !important;">home</v-icon>
        </v-badge>
        <v-icon style="font-size: 22px !important;color: #ffffff !important;" v-else>home</v-icon>
      </v-tab>

      <v-tab href="#tab-2" :key="2" @click="toTab(2)">
        <span style="color: white; text-transform: none;">{{$t('LeftSide.header.chat')}}</span>
        <v-badge v-model="showcountread" color="red" v-if="num_countread > 0">
          <span slot="badge" v-if="num_countread >= 1000">999+</span>
          <span slot="badge" v-else>{{num_countread}}</span>
          <v-icon style="font-size: 22px !important; color: #ffffff !important;">chat</v-icon>
        </v-badge>
          <v-icon v-else style="font-size: 22px !important; color: #ffffff !important;">chat</v-icon>
      </v-tab>

      <v-tab href="#tab-3" :key="3" @click="toTab(3)">
        <span style="color: white; text-transform: none;">{{$t('LeftSide.header.setting')}}</span>
        <v-icon style="font-size: 22px !important;color: #ffffff !important;">settings</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs" class="white elevation-1">
      <!-- tab friend -->
      <v-tab-item id="tab-1" style="height: 100vh;">
        <!-- style="height: calc(100vh - 128px);" -->
        <v-list dense style="padding-top: 0px;" class="layoutsearchweb">
          <v-container class="layoutsearchweb">
            <v-layout row wrap class="layoutsearchweb">
              <v-flex xs12 xl12 md12 sm12 lg12>
                <v-layout row wrap align-center>
                  <h2 class="mb-2">{{$t('LeftSide.header.homepage')}}</h2>
                  <v-spacer></v-spacer>
                  <!-- alert -->
                  <v-badge color="red" overlap v-model="show_alert" v-if="num_listalert != 0">
                    <span slot="badge" v-if="num_listalert < 100">{{num_listalert}}</span>
                    <span slot="badge" v-else>99+</span>
                    <v-menu offset-x>
                      <v-btn slot="activator" flat fab medium>
                        <v-icon style="color: #848383;">mdi-bell-ring-outline</v-icon>
                      </v-btn>
                      <v-list>
                        <v-list-tile v-for="item in list_alert" :key="item.announce_id" style="width: 140px !important;">
                          <v-list-tile-title v-if="item.state == 'true'" @click="dialog_alert(item)">
                            <v-icon>mdi-bell-ring-outline</v-icon>
                            <span class="text-span">{{ item.message }}</span>
                          </v-list-tile-title>
                          <v-list-tile-title v-else-if="item.state == 'false'">
                            <v-icon style="color: #aeb5bb !important;">mdi-bell-off-outline</v-icon>
                            <span class="text-span-dis">{{ item.message }}</span>
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-menu>
                  </v-badge>
                  <v-menu offset-x v-else>
                    <v-btn slot="activator" flat fab medium>
                      <v-icon style="color: #848383;">mdi-bell-ring-outline</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile v-for="item in list_alert" :key="item.announce_id" style="width: 140px !important;">
                        <v-list-tile-title v-if="item.state == 'true'" @click="dialog_alert(item)">
                          <v-icon>mdi-bell-ring-outline</v-icon>
                          <span class="text-span">{{ item.message }}</span>
                        </v-list-tile-title>
                        <v-list-tile-title v-else-if="item.state == 'false'">
                          <v-icon style="color: #aeb5bb !important;">mdi-bell-off-outline</v-icon>
                          <span class="text-span-dis">{{ item.message }}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <v-layout row wrap class="mb-3">
                  <v-flex xs2 md2 sm2 lg2 xl2>
                    <v-avatar size="50px" slot="activator">
                      <img v-if="profilepicture !== ''" :src="profilepicture" class="alligator-turtle" style="cursor: pointer;">
                      <!-- <img v-else-if="typeuser === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="cursor: pointer;"> -->
                      <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="cursor: pointer;">
                    </v-avatar>
                  </v-flex>
                  <v-flex xs10 md10 sm10 lg10 xl10>
                    <v-layout column wrap class="ml-3">
                      <h4 style="text-overflow: ellipsis; width: 200px; white-space: nowrap; overflow: hidden;">{{ name }}</h4>
                      <span style="text-overflow: ellipsis; width: 200px; white-space: nowrap; overflow: hidden;">{{ status_user }}</span>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 xl12 md12 sm12 lg12>
                <!-- <br> -->
                <v-text-field append-icon="search" :label="$t('LeftSide.searching')" solo clearable v-model="search"  class="bgsearchweb CSChatThai" style="color: white !important;"></v-text-field>
                <v-layout row wrap justify-center align-center class="scrolling-wrapper">
                  <v-flex v-for="(item, index) in listmenufriend" :key="index" style="justify-content: center; align-items: center; display: flex;">
                    <div>
                      <v-btn fab small outlined @click="toPage(item.path)" style="background-color: #2562af29;">
                        <v-icon style="justify-content: center; display: flex; font-size: 15px; color: #2562af;">{{item.icon}}</v-icon>
                      </v-btn>
                      <p class="mb-0" style="justify-content: center; display: flex; font-size: 12px;">{{item.title}}</p>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 xl12 md12 sm12 lg12 :style="heightlistfriend" class="scroll-y">
                <v-expansion-panel >
                  <v-expansion-panel-content  class="expansion_container">
                    <b slot="header" class="CSChatThai" v-if="GroupReq.length != 0">{{$t('LeftSide.friend.groupInvite')}} ({{GroupReq.length}})</b>
                    <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%; cursor: pointer;" v-if="GroupReq.length != 0" v-for="(item, index) in GroupReq">
                      <!-- <template v-for="(item, index) in GroupReq" > -->
                        <div avatar   style="padding-top: 0px;" >
                          <v-list-tile  avatar  >
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;" @click="showUserInGroup(item)">
                              <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                              <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                            </v-list-tile-avatar>
                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontselect " style="font-size:13px;" @click="showUserInGroup(item)">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontselectchat " @click="showUserInGroup(item)">
                                <span class='fontselectchat '  style="font-size: 11px!important;">
                                  <!-- มีสมาชิก {{lengthactive(item.member,'statemember')}} คน -->
                                  {{$t('LeftSide.friend.haveMember', {count: lengthactive(item.member, 'statemember')})}}
                                </span>
                              </v-list-tile-sub-title>
                              <v-list-tile-sub-title class="CSChatThai">
                                <v-btn depressed small  class="btnallow text-transform" @click="AcceptReq_GroupReq(item)">
                                    {{$t('AnswerQuestion.joinGroup')}}
                                  </v-btn>
                                <v-btn depressed small class="btncancel text-transform" @click="RemoveReq_GroupReq(item)">
                                    {{$t('AnswerQuestion.cancel')}}
                                  </v-btn>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </div>
                        <v-divider v-if="index + 1 < GroupReq.length" :key="`divider-${index}`"></v-divider>
                      <!-- </template> -->
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
<!-- ------------------------------------------------------- -->
                <v-expansion-panel >
                  <v-expansion-panel-content class="expansion_container" >
                    <b slot="header" class="CSChatThai" v-if="FriendSendReq.length != 0">{{$t('LeftSide.friend.sendFriendInvite')}} ({{FriendSendReq.length}})</b>
                    <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;" v-if="FriendSendReq.length != 0">
                      <template v-for="(item, index) in FriendSendReq" >
                        <div avatar style="padding-top: 0px;">
                          <v-list-tile  avatar  >
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                              <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                            </v-list-tile-avatar>
                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontselect " style="font-size:13px;">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontselectchat ">
                                <span class='fontselectchat '  style="font-size: 11px!important;">
                                  {{$t('LeftSide.friend.waitingRequestFriend')}}
                                </span>
                              </v-list-tile-sub-title>
                              <v-list-tile-sub-title class="CSChatThai">
                                <v-btn depressed small class="btncancel text-transform" @click="RemoveReq_FriendSendReq(item)">
                                   {{$t('AnswerQuestion.cancel')}}
                                </v-btn>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </div>
                        <v-divider v-if="index + 1 < FriendSendReq.length" :key="`divider-${index}`"></v-divider>
                      </template>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
<!-- ------------------------------------------------------- -->
                <v-expansion-panel >
                  <v-expansion-panel-content class="expansion_container" >
                    <b slot="header" class="CSChatThai" v-if="FriendReq.length != 0">{{$t('LeftSide.friend.friendInvite')}} ({{FriendReq.length}})</b>
                    <v-list two-line subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;" v-if="FriendReq.length != 0">
                      <template v-for="(item, index) in FriendReq" >
                        <div avatar  style="padding-top:0px;">
                          <v-list-tile  avatar >
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                              <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                            </v-list-tile-avatar>
                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontselect " style="font-size:15px;">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontselectchat ">
                                <span class='fontselectchat '  style="font-size: 11px!important;">
                                  {{$t('LeftSide.friend.wantToBeFriend')}}
                                </span>
                              </v-list-tile-sub-title>
                              <v-list-tile-sub-title class="CSChatThai">
                                <v-btn depressed small class="btnallow text-transform" @click="AcceptReq_FriendReq(item)">
                                  {{$t('AnswerQuestion.acceptFriend')}}
                                </v-btn>
                                <v-btn depressed small class="btncancel text-transform" @click="RemoveReq_FriendReq(item)">
                                   {{$t('AnswerQuestion.cancel')}}
                                </v-btn>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </div>
                        <v-divider v-if="index + 1 < FriendReq.length" :key="`divider-${index}`"></v-divider>
                      </template>
                    </v-list>
                  </v-expansion-panel-content>
                </v-expansion-panel>
<!-- ------------------------------------------------------- -->
                <v-expansion-panel >
                  <v-expansion-panel-content class="expansion_container" >
                    <b slot="header" class="CSChatThai" v-if="FilterFriendList.length != 0">{{$t('LeftSide.friend.friend')}} ({{FilterFriendList.length}})</b>
                    <b slot="header" class="CSChatThai" v-else>{{$t('LeftSide.friend.friend')}}</b>
                    <v-list subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;" v-if="!ProgressListFriend">
                      <v-list-tile @click="toPage('/mobile/addfriend')">
                        <v-list-tile-content>
                          <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: black;">
                            <v-icon style="color: black;  font-size: 18px !important;">add_circle</v-icon>
                            {{$t('LeftSide.friend.addFriend')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <template v-for="(item, index) in FilterFriendList" v-if="FilterFriendList.length != 0">
                        <div avatar  @click="routeChat(item)" style="padding-top: 0px;cursor: pointer;">
                          <v-list-tile avatar class="selectF" v-if="actionF == item.tokenroom">
                            <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                              <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                            </v-list-tile-avatar>

                            <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                              <v-list-tile-title class="fontselect " style="font-size:13px;">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title class="fontselectchat ">
                                <span class='text--primary fontselectchat ' v-if="item.status !== ''" style="font-size: 11px!important;">
                                  {{item.status}}
                                </span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>

                            <v-list-tile-action v-if="item.type === 'bot'">
                              <v-icon color="grey lighten-1" style="font-size: 16px !important;">fas fa-robot</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                          <v-list-tile avatar v-else class="nonselectF">
                            <v-list-tile-avatar  style="padding-left: 1vw; margin-right: 1vw;">
                              <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle" >
                              <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title style="font-size:13px;color: black !important;">
                                {{item.name}}
                              </v-list-tile-title>
                              <v-list-tile-sub-title >
                                <span class='text--primary  ' v-if="item.status !== ''" style="color: #7a7a7a !important; font-size: 10px!important;">
                                  {{item.status}}
                                </span>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action v-if="item.type === 'bot'">
                              <v-icon color="grey lighten-1" style="font-size: 16px !important;">fas fa-robot</v-icon>
                            </v-list-tile-action>
                          </v-list-tile>
                        </div>
                        <v-divider v-if="index + 1 < FilterFriendList.length" :key="`divider-${index}`"></v-divider>
                      </template>
                    </v-list>
                    <div v-else>
                      <v-progress-linear :indeterminate="ProgressListFriend"></v-progress-linear>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
<!-- ------------------------------------------------------- -->
                <v-expansion-panel >
                  <v-expansion-panel-content  class="expansion_container" >
                    <b slot="header" class="CSChatThai" v-if="FilterGroupList.length != 0">{{$t('LeftSide.friend.group')}} ({{FilterGroupList.length}})</b>
                    <b slot="header" class="CSChatThai" v-else>{{$t('LeftSide.friend.group')}}</b>
                    <div subheader v-if="!ProgressListGroup">
                      <v-list subheader style="padding-left: 0px; padding-right: 0px; background-color: #fff !important; width: 100%;cursor: pointer;" >

                        <v-list-tile @click="toPage('/mobile/creategroup')">
                          <v-list-tile-content>
                            <v-list-tile-title class="CSChatThai " style="font-size:12px;text-align:center;color: black;">
                              <v-icon style="color: black;  font-size: 18px !important;">add_circle</v-icon>
                              {{$t('LeftSide.friend.createGroup')}}
                            </v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>

                        <template v-for="(item, index) in FilterGroupList" v-if="FilterGroupList.length != 0">
                          <div avatar   @click="routeChat(item)" style="padding-top: 0px;">
                            <v-list-tile  avatar  class="selectF" v-if="actionF == item.tokenroom">
                              <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                                <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                                <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              </v-list-tile-avatar>

                              <v-list-tile-content style="margin-right: 0vw;padding-right: 1vw;">
                                <v-list-tile-title class="fontselect " style="font-size:13px;">
                                  {{item.name}}
                                </v-list-tile-title>

                              </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile avatar v-else class="nonselectF">
                              <v-list-tile-avatar  style="padding-left: 1vw; margin-right: 1vw;">
                                <img v-if="item.picture" :src="item.picture" class="alligator-turtle">
                                <img v-else src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                              </v-list-tile-avatar>
                              <v-list-tile-content>
                                <v-list-tile-title style="font-size:13px;color: black !important;">
                                  {{item.name}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </div>
                          <v-divider v-if="index + 1 < FilterGroupList.length" :key="`divider-${index}`"></v-divider>
                        </template>
                      </v-list>
                    </div>
                    <div v-else>
                      <v-progress-linear :indeterminate="ProgressListGroup"></v-progress-linear>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list>
      </v-tab-item>
      <!-- tab chat -->
      <v-tab-item id="tab-2">
        <v-list dense style="padding-top: 0px !important;" class="layoutsearchweb">
          <v-container class="layoutsearchweb">
            <v-layout row wrap  class="layoutsearchweb">
              <v-flex xs12 xl12 md12 sm12 lg12>
                <v-layout row wrap align-center>
                  <h2 class="mb-2">{{$t('LeftSide.header.chat')}}</h2>
                  <v-spacer></v-spacer>
                  <v-menu offset-y>
                    <template slot="activator">
                      <v-btn icon small>
                        <v-icon color="grey">fas fa-plus-circle</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in listmenuchat"
                        :key="index"
                        @click="toPage(item.path)"
                      >
                        <v-list-tile-title>
                          <v-layout row wrap>
                            <v-icon style="font-size: 15px; color: #2562af;">{{item.icon}}</v-icon>
                            <span class="ml-3"> {{ item.title }} </span>
                          </v-layout>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-layout>
              </v-flex>
              <v-flex xs12 xl12 md12 sm12 lg12>
                <v-text-field  append-icon="search" :label="$t('LeftSide.searching')" solo clearable v-model="search"  class="bgsearchweb CSChatThai"></v-text-field>
              </v-flex>
              <v-flex xs12 xl12 md12 sm12 lg12 :style="heightlistchat" class="scroll-y" v-if="!ProgressListChat">
                <!-- style="max-height: calc(100vh - 210px);" -->
                <!-- max-height: calc(100vh - 200px); -->
                <vue-context ref="menu" style="z-index: 1500;">
                   <li v-for="list in ListMenuRightClick">
                     <a @click="SelectMenuRightClick(list.methods)">{{list.message}}</a>
                   </li>
                </vue-context>
                <v-list two-line subheader class="backgroundlistchat">
                  <template v-if="FilterChatList.length === 0">
                    <v-layout align-center justify-center row>
                      <h4>{{$t('LeftSide.noDataSearching')}}</h4>
                    </v-layout>
                  </template>
                  <template v-for="(item, index) in FilterChatList" v-else>
                    <div avatar @click="routeChat(item)" style="padding-top: 0px;" v-if="item.is_active == 'true'" :key="index">
                      <v-list-tile  avatar  class="selectF" v-if="actionF == item.tokenroom" @contextmenu.prevent="RightClickDialog($event, ['pinchat'], item)">
                        <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                          <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                          <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else-if="item.type === 'group'" src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">

                          <v-badge color="primary" v-if="item.pin == 'true'">
                            <img slot="badge" src="/static/img/icons/pin@3x.png" style="width:16px; height: 16px;" class="img-pin">
                          </v-badge>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="fontselect" >
                            {{item.name}}
                          </v-list-tile-title>
                          <v-list-tile-sub-title class="fontselectchat">
                            <span class='fontselectchat' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.leftChat')}}
                            </span>
                            <span class='fontselectchat text2'
                               v-else-if="item.typeofmessage === 'message'"
                               style="font-size: 11px!important;"
                               v-html="convertMention(item.message)"
                            >
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'sticker'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendSticker')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'file' || item.typeofmessage == 'password_file'" style="font-size: 11px!important;">
                             {{$t('LeftSide.chat.sendFile')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'location'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendLocation')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'contact'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendContact')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'image'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendPicture')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'note'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendNote')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'video'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendVideo')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'mention_message'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendReply')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'albums_message'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.createAlbum')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'task_message'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.createTask')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action_task'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.createProject')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'unsend_message'" style="font-size: 11px!important;">
                              <!-- ยกเลิกข้อความ -->
                              {{item.message}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'carousel'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendCarousel')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'conference_msg'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendConference_msg')}}
                            </span>
                            <span class='fontselectchat text2' v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime'" style="font-size: 11px!important;">
                              {{item.message}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'call'" style="font-size: 11px!important;">
                              <div v-if="item.message === 'success'" class="text2">
                                <v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone fa-rotate-90</v-icon> {{$t('LeftSide.chat.call.time')}} {{secondsToHms(item.time_count)}}
                              </div>
                              <div v-else-if="item.message === 'decline' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.noResponse')}}
                              </div>
                              <div v-else-if="item.message === 'decline' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                              </div>
                              <div v-else-if="item.message === 'cancle' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                              </div>
                              <div v-else-if="item.message === 'cancle' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                              </div>
                              <div v-else-if="item.message === 'cancel' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                              </div>
                              <div v-else-if="item.message === 'cancel' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                              </div>
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action'" style="font-size: 11px!important;">
                              <div v-if="item.message === 'invite'" class="text2">
                                {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                              </div>
                              <div v-else-if="item.message === 'kick'" class="text2">
                                <!-- {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม -->
                                {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                              </div>
                              <div v-else-if="item.message === 'leave' && item.tokenuser === tokenuser">
                                {{$t('ChatSide.system.self.leftGroup')}}
                              </div>
                              <div v-else-if="item.message === 'leave' && item.tokenuser !== tokenuser" class="text2">
                                <!-- {{item.nickname}} ออกจากกลุ่ม -->
                                {{$t('ChatSide.system.other.leftGroup', { name: item.nickname} )}}
                              </div>
                              <div v-else-if="item.message === 'active' && item.tokenuser === tokenuser">
                                <!-- คุณเข้าร่วมกลุ่ม -->
                                {{$t('ChatSide.system.self.joinGroup')}}
                              </div>
                              <div v-else-if="item.message === 'active' && item.tokenuser !== tokenuser" class="text2">
                                <!-- {{item.nickname}} เข้าร่วมกลุ่ม -->
                                {{$t('ChatSide.system.other.joinGroup', { name: item.nickname} )}}
                              </div>
                            </span>
                            <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'" style="font-size: 11px!important;">
                              <!-- เริ่มต้นการสนทนา -->
                              {{$t('LeftSide.chat.startChat')}}
                            </span>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <p style="color: rgb(82, 82, 82) !important; font-size: 11px;" v-if="item.timestamp !== '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user')">
                            {{time(item.timestamp)}}
                          </p>
                          <p style="margin-right: 2vw;" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                            <v-badge color="red" >
                              <span slot="badge" class="Kanit" style="font-size: 12px;" v-if="parseInt(item.count_read) >= 1000">999+</span>
                              <span v-else-if="item.count_read != '' && parseInt(item.count_read) != 0 && item.message != ''" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >{{item.count_read}}</span>
                            </v-badge>
                          </p>
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-list-tile  avatar  class="nonselectF" v-else @contextmenu.prevent="RightClickDialog($event, ['pinchat'], item)">
                        <v-list-tile-avatar style="padding-left: 1vw;margin-right: 1vw;">
                          <img v-if="item.picture" :src="item.picture" class="alligator-turtle" >
                          <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else-if="item.type === 'government'" src='/static/img/default_profile/business-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else-if="item.type === 'group'" src='/static/img/default_profile/group-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">
                          <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle" style="border-style: solid; border-width: thin; border-color: #dde1e3;">

                          <v-badge color="primary" v-if="item.pin == 'true'">
                            <img slot="badge" src="/static/img/icons/pin@3x.png" class="img-pin" style="width:16px; height: 16px;">
                          </v-badge>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title class="nonfontselect">
                            <v-layout row wrap align-center>
                              <p style="width: 110px; overflow: hidden; text-overflow: ellipsis;">{{item.name}}</p>
                              <v-spacer></v-spacer>
                              <p style="color: rgb(82, 82, 82) !important; font-size: 11px;" v-if="item.timestamp !== '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user')">
                                {{time(item.timestamp)}}
                              </p>
                            </v-layout>
                          </v-list-tile-title>
                          <v-list-tile-sub-title class="fontselectchat">
                            <v-layout row wrap align-center>

                            <span class='fontselectchat' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.leftChat')}}
                            </span>
                            <span class='fontselectchat text2'
                              v-else-if="item.typeofmessage === 'message'"
                              style="font-size: 11px!important;"
                              v-html="convertMention(item.message)"
                            >
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'sticker'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendSticker')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'file' || item.typeofmessage === 'password_file' " style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendFile')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'location'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendLocation')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'contact'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendContact')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'image'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendPicture')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'note'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendNote')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'video'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendVideo')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'mention_message'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendReply')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'albums_message'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.createAlbum')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'task_message'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.createTask')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action_task'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.createProject')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'unsend_message'" style="font-size: 11px!important;">
                              <!-- ยกเลิกข้อความ -->
                              {{item.message}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'carousel'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendCarousel')}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'conference_msg'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.sendConference_msg')}}
                            </span>
                            <span class='fontselectchat text2' v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime'" style="font-size: 11px!important;">
                              {{item.message}}
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'call'" style="font-size: 11px!important;">
                              <div v-if="item.message === 'success'" class="text2">
                                <v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone fa-rotate-90</v-icon> {{$t('LeftSide.chat.call.time')}}  {{secondsToHms(item.time_count)}}
                              </div>
                              <div v-else-if="item.message === 'decline' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.noResponse')}}
                              </div>
                              <div v-else-if="item.message === 'decline' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                              </div>
                              <div v-else-if="item.message === 'cancle' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                              </div>
                              <div v-else-if="item.message === 'cancle' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                              </div>
                              <div v-else-if="item.message === 'cancel' && item.tokenuser === tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.cancel')}}
                              </div>
                              <div v-else-if="item.message === 'cancel' && item.tokenuser !== tokenuser"><v-icon style="font-size: 13px; color: #716262; margin-right: 5px;">fas fa-phone-slash fa-rotate-90</v-icon>{{$t('LeftSide.chat.call.missed')}}
                              </div>
                            </span>
                            <span class='fontselectchat' v-else-if="item.typeofmessage === 'system_action'" style="font-size: 11px!important;">
                              <div v-if="item.message === 'invite'" class="text2">
                                {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                              </div>
                              <div v-else-if="item.message === 'kick'" class="text2">
                                {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
                              </div>
                              <div v-else-if="item.message === 'leave' && item.tokenuser === tokenuser">
                                {{$t('ChatSide.system.self.leftGroup')}}
                              </div>
                              <div v-else-if="item.message === 'leave' && item.tokenuser !== tokenuser" class="text2">
                                {{$t('ChatSide.system.other.leftGroup', { name: item.nickname} )}}
                              </div>
                              <div v-else-if="item.message === 'active' && item.tokenuser === tokenuser">
                                {{$t('ChatSide.system.self.joinGroup')}}
                              </div>
                              <div v-else-if="item.message === 'active' && item.tokenuser !== tokenuser" class="text2">
                                {{$t('ChatSide.system.other.joinGroup', { name: item.nickname} )}}
                              </div>
                            </span>
                            <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'" style="font-size: 11px!important;">
                              {{$t('LeftSide.chat.startChat')}}
                            </span>
                            <v-spacer></v-spacer>
                            <p style="margin-right: 5vw;" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                              <v-badge color="red">
                                <span slot="badge" class="Kanit" style="font-size: 12px;" v-if="parseInt(item.count_read) >= 100">99+</span>
                                <span v-else-if="item.count_read != '' && parseInt(item.count_read) != 0 && item.message != ''" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >{{item.count_read}}</span>
                              </v-badge>
                            </p>
                          </v-layout>
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <!-- <v-list-tile-action>
                          <p style="margin-right: 7vw; color: rgb(82, 82, 82) !important; font-size: 11px;" v-if="item.timestamp !== '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user')">
                            {{time(item.timestamp)}}
                          </p>
                          <p style="margin-right: 2vw;" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                            <v-badge color="red" >
                              <span slot="badge" class="Kanit" style="font-size: 12px;" v-if="parseInt(item.count_read) >= 1000">999+</span>
                              <span v-else-if="item.count_read != '' && parseInt(item.count_read) != 0 && item.message != ''" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >{{item.count_read}}</span>
                            </v-badge>
                          </p>
                        </v-list-tile-action> -->
                      </v-list-tile>
                      <!-- <v-divider v-if="index + 1 < FilterChatList.length" :key="`divider-${index}`"></v-divider> -->

                      <v-divider
                        v-if="index < FilterChatList.length - 1"
                        :key="`divider-${index}`"
                      ></v-divider>
                    </div>
                    <!-- <v-divider v-if="item.is_active == 'true'"></v-divider> -->
                  </template>
                </v-list>
              </v-flex>
              <v-flex xs12 xl12 md12 sm12 lg12 style="max-height: 80vh;" class="scroll-y" v-else>
                <v-layout align-center justify-center row>
                  <v-progress-linear :indeterminate="ProgressListChat" color="primary"></v-progress-linear>
                 </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list>
      </v-tab-item>
      <!-- tab setting -->
      <v-tab-item id="tab-3">
        <!-- calc(100vh - 128px) -->
        <v-layout row wrap class="mt-3 ml-3" >
          <h2>{{$t('LeftSide.header.setting')}}</h2>
        </v-layout>
        <v-layout row wrap justify-start :style="heightlistsetting" class="scrolling-wrapper-setting">
          <v-list dense two-line style="width: 100%;">
            <v-subheader style="background-color: #efefef !important; color: black !important; font-size: 14px !important;">{{$t('HeaderMenubar.profile')}}</v-subheader>
            <template v-for="(item, index) in listsetting">
              <v-list-tile
                :key="item.title"
                @click="toPage(item.dialog)"
              >
                <v-icon meduim>{{item.icon}}</v-icon>&nbsp;&nbsp;
                  <v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
              </v-list-tile>
              <v-divider
                v-if="index + 1 < listsetting.length"
                :key="index"
              ></v-divider>
            </template>
          <v-divider></v-divider>
          <v-list-tile @click="openloa()">
            <v-icon style="font-size: 18px;">fas fa-user-shield</v-icon>&nbsp;&nbsp;
              <v-list-tile-title class="CSChatThai">{{$t('HeaderMenubar.loa')}}</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-list dense two-line style="width: 100%;">
          <v-subheader style="background-color: #efefef !important; color: black !important; font-size: 14px !important;">One Platform Service</v-subheader>
          <template v-for="(item, index) in listservice">
            <v-list-tile
              :key="item.title"
              @click="changepathservice(item.path, item.type)"
            >
              <v-icon v-if="item.icon !== ''" meduim >{{item.icon}}</v-icon>
              <img v-else :src="item.img" alt="" width="30" height="30">
              &nbsp;&nbsp;
                <v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < listservice.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
        <v-list dense two-line style="width: 100%;">
          <v-subheader style="background-color: #efefef !important; color: black !important; font-size: 14px !important;">{{$t('HeaderMenubar.general')}}</v-subheader>
          <template v-for="(item, index) in listother">
            <v-list-tile
              :key="item.title"
              @click="toPage(item.dialog)"
            >
              <v-icon meduim>{{item.icon}}</v-icon>&nbsp;&nbsp;
                <v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < listother.length"
              :key="index"
            ></v-divider>
          </template>
          <v-divider></v-divider>
          <v-list-tile @click="logout()">
            <v-icon meduim>lock_open</v-icon>&nbsp;&nbsp;
              <v-list-tile-title class="CSChatThai">{{$t('HeaderMenubar.logout')}}</v-list-tile-title>
          </v-list-tile>
        </v-list>
        </v-layout>
      </v-tab-item>
      <!-- <CenterSideMobile :infofriend="infofriend"></CenterSideMobile> -->
      <ShowFriendDialog :dialogShowfriend="ShowFriend" v-on:closeDialogShowFriend="closeDialogShowFriend" :showgroup="showgroup"></ShowFriendDialog>
      <div style="display: none;">
        <CreateGroupMobile  @updatecreategroup="updatecreategroup" @updatelistchat="updatelistchat"></CreateGroupMobile>
        <Addfriend @updatelistreq="updatelistreq" @blockevent="blockevent"></Addfriend>
      </div>
    </v-tabs-items>
    <checkconsentOnechatDialog :url_consent="url_consent" :consentOnechatDialog="consentOnechatDialog" @closeDialogConsentOnechat="closeDialogConsentOnechat"></checkconsentOnechatDialog>
    <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser" :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>
  </div>
</vue100vh>
</template>
<script>
import { Momenttime, Decode, Encode } from '@/services'
import { sync } from 'vuex-pathify'
import ShowFriendDialog from '@/components/mobile/dialog/ShowFriendDialogMobile'
import CreateGroupMobile from '@/components/mobile/manage/Creategroup'
import Addfriend from '@/components/mobile/manage/Addfriend'
import CheckBrowserDialog from '@/components/chat/dialog/CheckBrowserDialog'
import checkconsentOnechatDialog from '@/components/chat/dialog/consent/consent_onechat_dialog'
import { VueContext } from 'vue-context';
import vue100vh from 'vue-100vh'
import VueScreenSize from 'vue-screen-size'
// import CenterSideMobile from '@/components/mobile/layout/CenterSideMobile'
var _ = require('lodash')
export default {
  mixins: [VueScreenSize.VueScreenSizeMixin],
  data () {
    return {
      // infofriend: false,
      // statemember: '',
      checkBrowserDialog: false,
      checkBrowserInfor: {},
      show_alert: false,
      num_listalert: 0,
      list_alert: [],
      rightclickdialog: false,
      num_friendreq: '',
      num_friendsendreq: '',
      num_groupreq: '',
      num_managefriend: '',
      showcountread: false,
      num_countread: '',
      showgroup: false,
      ShowFriend: false,
      listgroup: [],
      listfriend: [],
      listchat: [],
      FriendReq: [],
      FriendSendReq: [],
      GroupReq: [],
      ProgressListFriend: false,
      show: false,
      actionF: '',
      ProgressListChat: false,
      search: '',
      tokenuser: '',
      tabs: null,
      listmenuchat: [
        // {
        //   title: 'คิวอาร์โค้ด',
        //   icon: 'fas fa-qrcode',
        //   path: '/mobile/qrcode'
        // },
        // {
        //   title: 'เพิ่มเพื่อน',
        //   icon: 'fas fa-user',
        //   path: '/mobile/addfriend'
        // },
        // {
        //   title: 'สร้างกลุ่ม',
        //   icon: 'fas fa-users',
        //   path: '/mobile/creategroup'
        // }
      ],
      listmenufriend: [
        // {
        //   title: 'คิวอาร์โค้ด',
        //   icon: 'fas fa-qrcode',
        //   path: '/mobile/qrcode'
        // },
        // {
        //   title: 'เพิ่มเพื่อน',
        //   icon: 'fas fa-user',
        //   path: '/mobile/addfriend'
        // },
        // {
        //   title: 'สร้างกลุ่ม',
        //   icon: 'fas fa-users',
        //   path: '/mobile/creategroup'
        // },
        // {
        //   title: 'โปรเจค',
        //   icon: 'fas fa-tasks',
        //   path: '/mobile/task/project'
        // },
        // {
        //   title: 'ปฏิทิน',
        //   icon: 'fas fa-calendar',
        //   path: '/mobile/task/calendar'
        // }
      ],
      listsetting: [],
      listservice: [
        {
          title: 'OneEmail',
          icon: '',
          img: '/static/img/oneplatform/oneemail2.png',
          path: process.env.WEBoneEmail,
          type: 'link'
        },
        {
          title: 'OneBox',
          icon: '',
          img: '/static/img/oneplatform/onebox.png',
          path: process.env.WEBoneBox,
          type: 'share_token_onebox'
        },
        // {
        //   title: 'OneChat News',
        //   icon: '',
        //   img: '/static/img/oneplatform/onechat_news.jpg',
        //   path: process.env.WEBNews,
        //   type: 'function_news'
        // },
        {
          title: 'One Anonymous',
          icon: '',
          img: '/static/img/oneplatform/anonymousone.png',
          path: '/mobile/settings/anonymousone_group',
          type: 'route'
        },
        // {
        //   title: 'ส่งไฟล์ไป One box',
        //   icon: 'file_upload',
        //   path: '/mobile/settings/uploadfile/onebox',
        //   type: 'route'
        // }
      ],
      listother: [],
      SelectedMessageDetail: {},
      ListMenuRightClick: [],
      profilepicture: '',
      name: '',
      status_user: '',
      heightlistchat: '',
      heightlistfriend: '',
      heightlistsetting: '',
      encodeToken_News: '',
      one_id: '',
      consentOnechatDialog: false,
      url_consent: '',
    }
  },
  created () {
    // this.heightlistchat = 'height: ' + (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0)) + 'px;'
    // this.heightlistchat = 'height: ' + (this.$vssHeight - 210.0) + 'px;'
    // this.heightlistfriend = 'height: ' + (this.$vssHeight - 405.0) + 'px;'
    this.heightlistchat = 'height: ' + (this.$vssHeight - 170.0) + 'px;'
    this.heightlistfriend = 'height: ' + (this.$vssHeight - 335.0) + 'px;'
    this.heightlistsetting = 'height: ' + (this.$vssHeight - 110.0) + 'px;'
    this.actionF = this.$route.params.roomid
    var decoded = JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
    this.tabs = localStorage.getItem('tabs')
    this.profilepicture = localStorage.getItem('profilepicture')
    this.name = localStorage.getItem('name')
    this.status_user = localStorage.getItem('status')
    this.$i18n.locale = (this.$cookie.get('language'))? this.$cookie.get('language'): 'th'
    this.changeLangMenu()
    this.getlistchat()
    this.getlistfriend()
    this.getlistgroup()
    this.getlistalert()
    this.getOneid()
    this.getlistpending()
    // console.log(this.$cookie.get('language'))
  },
  components: {
    ShowFriendDialog,
    CreateGroupMobile,
    Addfriend,
    VueContext,
    vue100vh,
    CheckBrowserDialog,
    checkconsentOnechatDialog
    // Editprofile
    // CenterSideMobile
  },
  computed: {
    FilterFriendList () {
      if (this.search !== '' && this.search !== null) {
        return this.listfriend.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listfriend
      }
    },
    FilterGroupList () {
      if (this.search !== '' && this.search !== null) {
        return this.listgroup.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listgroup
      }
    },
    FilterChatList () {
      if (this.search !== '' && this.search !== null) {
        return this.listchat.filter(post => {
          return post.name.toLowerCase().includes(this.search.toLowerCase())
        })
      } else {
        return this.listchat
      }
    },
    ...sync('*')
  },
  watch: {
    '$i18n.locale' () {
      this.changeLangMenu()
    },
    '$vssHeight' () {
      // this.box_height = (this.$vssHeight - ((34.0 + 40.0 + 82.0) - 10.0))
      // console.log('height center ==> '+ this.$vssHeight)
      // this.heightlistchat = 'height: ' + (this.$vssHeight - 210.0) + 'px;'
      // this.heightlistfriend = 'height: ' + (this.$vssHeight - 405.0) + 'px;'
      this.heightlistchat = 'height: ' + (this.$vssHeight - 170.0) + 'px;'
      this.heightlistfriend = 'height: ' + (this.$vssHeight - 335.0) + 'px;'
      this.heightlistsetting = 'height: ' + (this.$vssHeight - 110.0) + 'px;'
      // console.log(this.$vssHeight)
    },
    myprofilepicture () {
      this.profilepicture = localStorage.getItem('profilepicture')
    },
    myname () {
      this.name = localStorage.getItem('name')
      // console.log(this.name)
    },
    mystatus () {
      this.status_user = localStorage.getItem('status')
    },
    tabs () {
      localStorage.setItem('tabs', this.tabs)
    },
    chIsactive (data) {
      var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data })
      this.listchat[indexmsg].is_active = false
      this.$router.push('/mobile/homepage')
      this.axios.post(process.env.APImanage + '/setpin', {tokenroom: data, tokenuser: this.tokenuser, pin: 'false'}).then((response) => {
        var listpin = []
        var linstunpin = []
        this.listchat[indexmsg].pin = 'false'
        this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
        listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
        linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
        this.listchat = _.union(listpin, linstunpin)
      })
    },
    block_friend (data) {
      // console.log(data)
      this.blockevent(data)
    },
    centrifuge_consent (data) {
      if (data.consent_version !== undefined) {
        this.consentOnechatDialog = false
      }
    },
    socket_unsendmessage (data) {
      // console.log(data)
      this.axios.post(process.env.APIpub + '/getmessage', {tokenmessage: data.last_tokenmessage, tokenuser: this.tokenuser}).then((response) => {
        // console.log(response.data.source)
        var dataunsend = {}
        dataunsend = response.data.source
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        if (indexmsg !== -1) {
          this.listchat[indexmsg].is_active = 'true'
          // var message = dataunsend.message
          if (data.tokenroom !== this.actionF) {
            this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1
          }
          if (indexmsg === 0) {
            this.listchat[0].message = dataunsend.message
            this.listchat[0].timestamp = dataunsend.timestamp
            this.listchat[0].nickname = dataunsend.nickname
            this.listchat[0].typeofmessage = dataunsend.typeofmessage
            this.listchat[0].time_count = dataunsend.time_count
            this.listchat[0].file_name = dataunsend.file_name
            this.listchat[0].tokenuser = dataunsend.tokenuser
          } else {
            var dataindex = this.listchat[indexmsg]
            dataindex.message = dataunsend.message
            dataindex.timestamp = dataunsend.timestamp
            dataindex.nickname = dataunsend.nickname
            dataindex.typeofmessage = dataunsend.typeofmessage
            dataindex.time_count = dataunsend.time_count
            dataindex.file_name = dataunsend.file_name
            dataindex.tokenuser = dataunsend.tokenuser
            _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
            this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
          }
        }
      })
    },
    socketmessage (data) {
      // console.log(data)
      // console.log(data.message)
      // var _ = require('lodash')
      var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      if (indexmsg !== -1) {
        this.listchat[indexmsg].is_active = 'true'
      }
      var message = data.message
      // if (data.typeofmessage !== 'message') {
      //   message = 'Send ' + data.typeofmessage
      // }
      if (data.tokenroom !== this.actionF && data.tokenuser != this.tokenuser) {
        this.listchat[indexmsg].count_read = (parseInt(this.listchat[indexmsg].count_read) + 1).toString()
        this.num_countread = this.num_countread + 1
        var indexblock = []
        var indexmessage = []
        var indexactive = []
        indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
        indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
        indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
        var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
        var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
        var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
        var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
        this.num_countread = count - ( countblock + countmsg + countactive)
        if (this.num_countread > 0) {
          this.showcountread = true
        } else {
          this.showcountread = false
        }

      }
      if (indexmsg === 0) {
        this.listchat[0].message = message
        this.listchat[0].timestamp = data.timestamp
        this.listchat[0].nickname = data.nickname
        this.listchat[0].typeofmessage = data.typeofmessage
        this.listchat[0].time_count = data.time_count
        this.listchat[0].file_name = data.file_name
        this.listchat[0].tokenuser = data.tokenuser
      } else {
        var dataindex = this.listchat[indexmsg]
        dataindex.message = message
        dataindex.timestamp = data.timestamp
        dataindex.nickname = data.nickname
        dataindex.typeofmessage = data.typeofmessage
        dataindex.time_count = data.time_count
        dataindex.file_name = data.file_name
        dataindex.tokenuser = data.tokenuser
        _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
        this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
      }
      // เรียงแชทใหม่ กรณที่มีการ pin
      var listpin = []
      var linstunpin = []
      this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
      listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
      linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
      this.listchat = _.union(listpin, linstunpin)
    },
    socketactive_group (data) {
      // console.log(data)
      this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: this.tokenuser}).then((response) => {
        // console.log(response.data)
        var indexgroup = _.findIndex(this.GroupReq, function (o) { return o.group_id === response.data.group.group_id }) // หาตำแหน่งของ group req ที่ต้องการจะลบ
        if (indexgroup >= 0) {
          _.pullAt(this.GroupReq, indexgroup) // ลบ GroupReq เดิม
          this.num_groupreq = this.GroupReq.length // จำนวน group req
        }
        // update listgroup
        if (_.find(this.listgroup, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
          var group = response.data.group
          group.timestamp = data.timestamp
          this.listgroup.unshift(group)
          this.listgroup = _.orderBy(this.listgroup, ['name'], ['asc'])
        }
        // update listchat
        // if (_.find(this.listchat, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
        //   var chat = response.data.group
        //   chat.timestamp = data.timestamp
        //   chat.count_read = ''
        //   chat.nickname = ''
        //   chat.is_active = 'true'
        //   this.listchat.unshift(chat)
        // }
        if (data.tokenuser === this.token) {
          var indexchat = _.findIndex(this.listchat, function (o) { return o.group_id === response.data.group.group_id }) // หาตำแหน่งของ group req ที่ต้องการจะลบ
          // console.log(indexchat)
          this.listchat[indexchat].state = 'active'
        }
      })
    },
    socketinvite_group (data) {
      // console.log(data)
      var index = _.findIndex(this.listgroup, function (o) { return o.tokenroom === data.tokenroom })
      if (index < 0) {
        this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: data.userinvited}).then((response) => {
          // console.log(response.data.group)
          this.GroupReq.unshift(response.data.group)
          this.GroupReq = _.orderBy(this.GroupReq, ['create_date'], ['asc'])
          this.num_groupreq = this.GroupReq.length
        })
      }
    },
    socketcencel_group (data) {
      // console.log(data)
      if (this.GroupReq.length !== 0) {
        // ลบ group req
        this.GroupReq.splice(this.findWithAttr(this.GroupReq, 'group_id', data.group_id), 1)
        this.num_groupreq = this.GroupReq.length
        // console.log(this.num_groupreq)
      }
    },
    socketleave_group (data) {
      // console.log(data)
      var self = this
      data.listkick.forEach(function (item) {
        if (item === self.token) {
          var index = _.findIndex(self.listgroup, function (o) { return o.tokenroom === data.tokenroom })
          if (index >= 0) {
            self.listgroup.splice(index, 1)
          }
          var indexchat = _.findIndex(self.listchat, function (o) { return o.tokenroom === data.tokenroom })
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave'
          }
        }
      })
    },
    socket_kickmember (data) {
      var self = this
      data.listkick.forEach(function (item) {
        if (item === self.tokenuser) {
          var index = _.findIndex(self.listgroup, function (o) { return o.tokenroom === data.tokenroom })
          if (index >= 0) {
            self.listgroup.splice(index, 1)
          }
          var indexchat = _.findIndex(self.listchat, function (o) { return o.tokenroom === data.tokenroom })
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave'
            var indexblock = []
            indexblock = _.filter(self.listchat, function (listchat) { return listchat.state !== 'active' })
            var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
            var count = _.sumBy(self.listchat, function (o) { return parseInt(o.count_read) })
            self.num_countread = count - countblock
          }
        }
      })
    },
    socketremove_request_friend (data) {
      // console.log(data)
      // var _ = require('lodash')
      var indexReq = _.findIndex(this.FriendReq, function (o) { return o.tokenuser === data.tokenuser })
      var indexSendReq = _.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser })
      if (indexReq >= 0) {
        this.FriendReq.splice(indexReq, 1)
        this.num_friendreq = this.FriendReq.length
      }
      if (indexSendReq >= 0) {
        this.FriendSendReq.splice(indexSendReq, 1)
        this.num_friendsendreq = this.FriendSendReq.length
      }
    },
    socketaccept_friend (data) {
      // console.log(data)
      var tokenfriend = data.tokenfriend
      if (this.tokenuser === data.tokenfriend) {
        tokenfriend = data.tokenuser
        var indexSendReq = _.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser })
        if (indexSendReq >= 0) {
          this.FriendSendReq.splice(indexSendReq, 1)
          this.num_friendsendreq = this.FriendSendReq.length
        }
      }
      this.axios.post(process.env.APImanage + '/searchtokenuser', {tokenuser: this.tokenuser, tokenfriend: tokenfriend}).then((response) => {
        if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
          this.listfriend.unshift(response.data.user)
          this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        }
        // update listchat
        var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        var json = response.data.user
        json.nickname = ''
        json.picture = response.data.user.profilepicture
        json.state = 'user'
        json.timestamp = data.timestamp
        json.count_read = 0
        json.is_active = 'true'
        // console.log(json)
        if (indexchat >= 0) {
          this.listchat.splice(indexchat, 1)
          this.listchat.unshift(json)
          // console.log(this.listchat)
        } else {
          this.listchat.unshift(json)
          // console.log(this.listchat)
        }
      })
      // เรียงแชทใหม่ กรณที่มีการ pin
      var listpin = []
      var linstunpin = []
      this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
      listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
      linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
      this.listchat = _.union(listpin, linstunpin)
    },
    socketremove_friend (data) {
      // console.log(data)
      var index = _.findIndex(this.listfriend, function (o) { return o.tokenroom === data.tokenroom })
      if (index >= 0) {
        this.listfriend.splice(index, 1)
      }
      var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      if (indexchat >= 0) {
        this.listchat[indexchat].state = 'unfriend'
      }
    },
    socketfriend (data) {
      // console.log(data)
      // console.log(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: data.tokenfriend})
      this.axios.post(process.env.APImanage + '/getuser', {owner: this.tokenuser, tokenuser: data.tokenfriend}).then((response) => {
        // var _ = require('lodash')
        if (data.konAdd !== this.tokenuser) {
          // update Friend request
          if (_.find(this.FriendReq, function (o) { return o.tokenuser === response.data.user[0].tokenuser }) === undefined) {
            this.FriendReq.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type
            })
            this.FriendReq = _.orderBy(this.FriendReq, ['name'], ['asc']).reverse()
            this.num_friendreq = this.FriendReq.length
          }
        } else {
          if (_.find(this.FriendSendReq, function (o) { return o.tokenuser === response.data.user[0].tokenuser }) === undefined) {
            this.FriendSendReq.unshift({
              email: response.data.user[0].email,
              name: response.data.user[0].name,
              phone: response.data.user[0].phone,
              profilepicture: response.data.user[0].profilepicture,
              state: response.data.user[0].state,
              status: response.data.user[0].status,
              tokenuser: response.data.user[0].tokenuser,
              type: response.data.user[0].type
            })
            this.FriendSendReq = _.orderBy(this.FriendSendReq, ['name'], ['asc']).reverse()
            this.num_friendsendreq = this.FriendSendReq.length
          }
        }
      })
    },
    socketcreate_group (data) {
      if (data.fromtokenuser !== this.tokenuser) {
        this.axios.post(process.env.APImanage + '/getgroup', {group_id: data.groupid, tokenuser: data.fromtokenuser}).then((response) => {
          // console.log(response.data)
          // var _ = require('lodash')
          if (_.find(this.GroupReq, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
            this.GroupReq.unshift({
              create_date: response.data.group.create_date,
              group_id: response.data.group.group_id,
              member: response.data.group.member,
              name: response.data.group.name,
              picture: response.data.group.picture,
              state: response.data.group.state,
              tokenroom: response.data.group.tokenroom,
              type: response.data.group.type,
              status: response.data.group.status,
              tokenuser: response.data.group.tokenuser,
              timestamp: response.data.group.create_date,
              count_read: '',
              nickname: ''
            })
            this.GroupReq = _.orderBy(this.GroupReq, ['create_date'], ['asc'])
            this.num_groupreq = this.GroupReq.length
          }
        })
      }
    },
    '$route.params.roomid' () {
      this.actionF = this.$route.params.roomid
    }
  },
  methods: {
    openloa () {
      var url = process.env.urlLoa
      var body = {
         "tokenuser": this.tokenuser,
         "url": url
        }
      this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
        // window.open(url + response.data.data.accesstoken, '_blank')
        this.checkBrowser(url + response.data.data.accesstoken)
      })
    },
    changeLangMenu () {
      this.listother = [
        {
          title: this.$t('HeaderMenubar.languages'),
          icon: 'fas fa-globe',
          dialog: '/mobile/settings/languages'
        },
        {
          title: this.$t('HeaderMenubar.feedback'),
          icon: 'feedback',
          dialog: '/mobile/settings/feedback'
        },
        {
          title: this.$t('HeaderMenubar.support'),
          icon: 'contact_support',
          dialog: '/mobile/settings/support'
        },
        {
          title: this.$t('HeaderMenubar.policy'),
          icon: 'book',
          dialog: '/mobile/settings/policy'
        },
        {
          title: this.$t('HeaderMenubar.terms_of_service'),
          icon: 'book',
          dialog: '/mobile/settings/terms_of_service'
        }
      ]
      this.listsetting = [
        {
          title: this.$t('HeaderMenubar.editProfile'),
          icon: 'person',
          dialog: '/mobile/settings/profile'
        },
        {
          title: this.$t('HeaderMenubar.managefriend'),
          icon: 'group',
          dialog: '/mobile/settings/managefriend'
        }
        // {
        //   title: this.$t('HeaderMenubar.loa'),
        //   icon: 'fas fa-user-shield',
        //   dialog: ''
        // }
      ]
      this.listmenufriend = [
        {
          title: this.$t('LeftSide.header.qrcode'),
          icon: 'fas fa-qrcode',
          path: '/mobile/qrcode'
        },
        {
          title: this.$t('LeftSide.addFiend.header'),
          icon: 'fas fa-user',
          path: '/mobile/addfriend'
        },
        {
          title: this.$t('LeftSide.createGroup.header'),
          icon: 'fas fa-users',
          path: '/mobile/creategroup'
        },
        {
          title: this.$t('LeftSide.header.project'),
          icon: 'fas fa-tasks',
          path: '/mobile/task/project'
        },
        {
          title: this.$t('LeftSide.header.calendar'),
          icon: 'fas fa-calendar',
          path: '/mobile/task/calendar'
        }
      ]
      this.listmenuchat = [
        {
          title: this.$t('LeftSide.header.qrcode'),
          icon: 'fas fa-qrcode',
          path: '/mobile/qrcode'
        },
        {
          title: this.$t('LeftSide.addFiend.header'),
          icon: 'fas fa-user',
          path: '/mobile/addfriend'
        },
        {
          title: this.$t('LeftSide.createGroup.header'),
          icon: 'fas fa-users',
          path: '/mobile/creategroup'
        }
      ]
    },
    getlistpending () {
      // this.axios.post(process.env.APImanage + '/web/getlistrequestfriend', {tokenuser: this.tokenuser}).then((response) => {
      //   this.FriendReq = response.data['listrequestfriend']
      //   this.num_friendreq = response.data['listrequestfriend'].length
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendingfriend', {tokenuser: this.tokenuser}).then((response) => {
      //   this.FriendSendReq = response.data['listpendingfriend']
      //   this.num_friendsendreq = response.data['listpendingfriend'].length
      // })
      // this.axios.post(process.env.APImanage + '/web/getlistpendinggroup', {tokenuser: this.tokenuser}).then((response) => {
      //   this.GroupReq = response.data['listpendinggroup']
      //   this.num_groupreq = response.data['listpendinggroup'].length
      // })
      // if (this.num_groupreq || this.num_friendsendreq || this.num_friendreq !== 0) {
      //   this.show = true
      // } else {
      //   this.show = false
      // }

      this.axios.post(process.env.APIgo_api + '/v1/get-list-pending', {tokenuser: this.tokenuser}).then((response) => {
        this.FriendSendReq = response.data['list_send_request_friend']
        this.FriendReq = response.data['list_request_friend']
        this.GroupReq = response.data['list_pending_group']

        this.num_friendreq = response.data['list_request_friend'].length
        this.num_groupreq = response.data['list_pending_group'].length
        this.num_friendsendreq = response.data['list_send_request_friend'].length

        if (this.num_groupreq || this.num_friendsendreq || this.num_friendreq !== 0) {
          this.show = true
        } else {
          this.show = false
        }
      })
    },
    closeCheckBrowser (value) {
      this.checkBrowserDialog = value
      this.checkBrowserInfor = {}
    },
    getOneid () {
      this.axios.get(process.env.APIgo_api + '/v1/getOneID/' + this.tokenuser).then((response) => {
        // console.log(response.data.one_id)
        this.one_id = response.data.one_id
      }, () => {
        console.log('error')
      })
    },
    changepathservice (path, type) {
      // console.log('type' + type)
      if (type == 'link') {
        window.open(path)
      } else if (type == 'route') {
        this.toPage(path)
      } else if (type == 'function_news') {
        // console.log('test')
        // console.log(Momenttime.momenttimestamp())
        var test = {
          one_id: this.one_id,
          createdDate: Momenttime.momentCreateDate()
        }
        this.encodeToken_News = Encode.encodeAuthen_news(test)
        window.open(path + this.encodeToken_News)
      } else if (type === 'share_token_onebox') {
        this.axios.post(process.env.APIimage + `/api/v1/get_encode_shared_token`, {
          user_id: this.one_id
        }).then((response) => {
          // console.log(response.data.data.encode_shared_token)
          var url = process.env.WEB_Redirect_Onebox + response.data.data.encode_shared_token
          this.checkBrowser(url)
        })
      }
    },
    checkBrowser (url) {
      // console.log(url)
      // console.log('check browser')
      // Get the user-agent string
      let userAgentString = navigator.userAgent;
      // Detect Chrome
      let chromeAgent = userAgentString.indexOf("Chrome") > -1;
      // Detect Internet Explorer
      let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
      // Detect Firefox
      let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
      // Detect Safari
      let safariAgent = userAgentString.indexOf("Safari") > -1;
      // Discard Safari since it also matches Chrome
      let operaAgent = userAgentString.indexOf("OP") > -1;
      // console.log('firefox = > ' + firefoxAgent)
      // console.log('ie = > ' + IExplorerAgent)
      // console.log('chrome = > ' + chromeAgent)
      // console.log('opera = > ' + operaAgent)
      // console.log('safari = > ' + safariAgent)
       if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
          this.checkBrowserInfor = {
            url: url,
            payload: ''
          }
          this.checkBrowserDialog = true
       } else if (safariAgent === true && chromeAgent === true) {
           window.open(url, '_blank')
       } else if (safariAgent === true) {
         this.checkBrowserInfor = {
           url: url,
           payload: ''
         }
         this.checkBrowserDialog = true
      } else {
        window.open(url, '_blank')
      }
    },
    convertMention(msg) {
      msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    logout () {
      this.$cookie.delete('tokenuser')
      this.$cookie.delete('status_login')
      localStorage.clear()
      // this.$router.push({
      //   path: '/login',
      //   force: true
      // })
      // console.log(`logout mo: ${this.$cookie.get('logouturl')}`)
      // if (process.env.LogoutOneid) {
      //   window.open(process.env.LogoutOneid, '_parent')
      // } else {
      //   this.$router.push({path: '/login', force: true})
      // }
      var logouturl = this.$cookie.get('logouturl')
      if (process.env.LogoutOneid) {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          window.open(process.env.LogoutOneid, '_parent')
        }
      } else {
        if (logouturl !== undefined && logouturl !== null) {
          window.open(logouturl + '?logout=true', '_parent')
          this.$cookie.delete('logouturl')
        } else {
          this.$router.push({path: '/login', force: true})
        }
      }
    },
    dialog_alert (item) {
      this.show_alert = false
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: item.message,
        type: 'warning',
        showCloseButton: true,
        reverseButtons: true,
        confirmButtonText: 'ตกลง'
      })
    },
    getlistalert () {
      this.axios.post(process.env.APImanage + '/getlistannounce', {}).then((response) => {
        this.list_alert = response.data.list_announce
        this.num_listalert = this.lengthstateactive(this.list_alert)
        this.show_alert = true
      })
    },
    lengthstateactive (list) {
      return _.filter(list, function (list) { return list.state === 'true' }).length
    },
    RightClickDialog ($event, list, item) {
      // console.log(list)
      // console.log(item)
      this.ListMenuRightClick = []
      if (item.state == 'active') {
        if (list.includes("pinchat")) {
          if (item.pin == "false") {
            this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.pinChat'), methods:'pinchat'})
          } else if (item.pin == "true") {
            this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.unpinChat'), methods:'unpinchat'})
          }
        }
        this.rightclickdialog = true
        this.$refs.menu.open($event)
        this.SelectedMessageDetail = item
      }
    },
    SelectMenuRightClick (selected) {
      // console.log(selected)
      if (selected == 'pinchat') {
        this.pin_chat()
      } else if (selected == 'unpinchat') {
        this.unpin_chat()
      }
    },
    pin_chat () {
      this.axios.post(process.env.APImanage + '/setpin', {
        tokenuser: this.tokenuser,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'true'
      }).then((response) => {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = this.SelectedMessageDetail.tokenroom
          var index = ''
          index = _.findIndex(this.listchat, function(o) { return o.tokenroom == tokenroom })
          this.listchat[index].pin = 'true'
          var listpin = []
          var linstunpin = []
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // console.log(this.listchat)
        }
      }, () => {
        console.log('error')
      })
    },
    unpin_chat () {
      this.axios.post(process.env.APImanage + '/setpin', {
        tokenuser: this.tokenuser,
        tokenroom: this.SelectedMessageDetail.tokenroom,
        pin: 'false'
      }).then((response) => {
        if (response.data.status === 'success') {
          // pinchat
          var tokenroom = this.SelectedMessageDetail.tokenroom
          var index = ''
          index = _.findIndex(this.listchat, function(o) { return o.tokenroom == tokenroom })
          this.listchat[index].pin = 'false'
          var listpin = []
          var linstunpin = []
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // console.log(this.listchat)
        }
      }, () => {
        console.log('error')
      })
    },
    secondsToHms (d) {
      d = Number(d)
      var hours = Math.floor(d / 3600)
      var minutes = Math.floor((d - (hours * 3600)) / 60)
      var seconds = d - (hours * 3600) - (minutes * 60)
      var time = ''

      if (hours !== 0) {
        time = hours + ':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
        time += minutes + ':'
      }
      if (time === '') {
        time = seconds + ' วินาที'
      } else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    blockevent (data) {
      // console.log(data)
      if (data.event === 'block_friend') {
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenuser === data.tokenuser })
        this.listchat[indexmsg].timestamp = data.timestamp
        this.listchat[indexmsg].state = 'block'
        // this.listchat = _.orderBy(this.listchat, ['timestamp'], ['asc']).reverse()
        // indexmsg = _.findIndex(this.listfriend, function (o) { return o.tokenuser === data.tokenuser })
        // _.pullAt(this.listfriend, indexmsg)
        this.axios.post(process.env.APImanage + '/setpin', {tokenroom: data.tokenroom, tokenuser: this.tokenuser, pin: 'false'}).then((response) => {
          var listpin = []
          var linstunpin = []
          this.listchat[indexmsg].pin = 'false'
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true' })
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
        })
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data)
        this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        this.listchat[indexmsg].state = 'active'
        this.listchat[indexmsg].nickname = ''
      }
    },
    AcceptReq_FriendReq (item) {
      this.axios.post(process.env.APInew_acceptfriend, {tokenfriend: item.tokenuser, tokenuser: this.tokenuser}).then((response) => {
        if (response.data.status === 'success') {
          this.FriendReq.splice(_.findIndex(this.FriendReq, function (o) { return o.tokenuser === item.tokenuser }), 1)
          this.$router.push('/mobile/room/' + response.data.tokenroom)
          localStorage.setItem('room', response.data.tokenroom)
          var data = response.data.source
          data['tokenroom'] = response.data.tokenroom
        } else {
          // this.$swal('', 'ไม่สามารถตอบรับเพื่อนได้ กรุณาลองใหม่ภายหลัง', 'warnning')
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
        }
      })
    },
    RemoveReq_FriendReq (item) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: item.tokenuser, tokenuser: this.tokenuser}).then((response) => {
        if (response.data.status === 'success') {
          this.FriendReq.splice(_.findIndex(this.FriendReq, function (o) { return o.tokenuser === item.tokenuser }), 1)
          this.num_friendreq = this.FriendReq.length
          // localStorage.setItem('FriendReq', Friend)
        }
      })
    },
    RemoveReq_FriendSendReq (item) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {tokenfriend: item.tokenuser, tokenuser: this.tokenuser}).then((response) => {
        if (response.data.status === 'success') {
          this.FriendSendReq.splice(_.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === item.tokenuser }), 1)
          this.num_friendsendreq = this.FriendSendReq.length
        }
      })
    },
    AcceptReq_GroupReq (group) {
      // process.env.APImanage + '/activeinvitegroup'
      // process.env.APIgo_api + '/v1/accept-group'
      this.axios.post(process.env.APIgo_api + '/v1/accept-group', {group_id: group.group_id, tokenuser: this.tokenuser}).then((response) => {
        // console.log(response)
        if (response.data.status === 'success') {
          var tokenuser = this.tokenuser
          var indexgroup = _.findIndex(response.data.group.member, function (o) { return o.tokenuser === tokenuser })
          if (indexgroup >= 0) {
            this.socketactive_group = {timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: group.group_id, tokenuser: this.token}
          } else {
            this.socketactive_group = {timestamp: '', groupid: group.group_id, tokenuser: this.token}
          }
        }
      })
    },
    RemoveReq_GroupReq (group) {
      // console.log(group)
      this.$swal({
        // title: 'คุณแน่ใจหรือไหม?',
        text: this.$t('Alert.Group.cancelGroup', { name: group.name }),
        type: 'warning',
        // imageUrl: '../assets/image/block.png',
        imageHeight: 70,
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APImanage + '/cancelinvitegroup', {group_id: group.group_id, tokenuser: this.tokenuser}).then((response) => {
            if (response.data.status === 'success') {
              // console.log(response.data)
              this.$swal('', this.$t('Alert.Success.success'), 'success')
              // this.socketcencel_group = group.group_id
              // console.log(this.socketcencel_group)
              // this.GroupReq.splice(this.GroupReq.indexOf(group), 1) // ลบ GroupReq ตอนยกเลิกเข้ากลุ่ม
              // this.$store.dispatch('groupReq', 'groupremove' + group)
            } else {
              this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'warning')
            }
          })
        }
      })
    },
    updatelistreq (data) {
      // console.log(data)
      if (data.event === 'accept') {
        this.FriendReq.splice(_.findIndex(this.FriendReq, function (o) { return o.tokenuser === data.tokenuser }), 1)
        if (_.find(this.listfriend, function (o) { return o.tokenuser === data.tokenuser }) === undefined) {
          this.listfriend.unshift({
            email: data.email,
            name: data.name,
            // phone: data.phone,
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom
          })
          this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        }
        if (_.find(this.listchat, function (o) { return o.tokenuser === data.tokenuser }) === undefined) {
          // console.log('listchat')
          this.listchat.unshift({
            email: data.email,
            name: data.name,
            // phone: response.data.user[0].phone,
            is_active: 'true',
            profilepicture: data.profilepicture,
            state: data.state,
            status: data.status,
            tokenuser: data.tokenuser,
            type: data.type,
            tokenroom: data.tokenroom,
            nickname: '',
            timestamp: data.timestamp,
            count_read: ''
          })
        }
      } else if (data.event === 'removeReq') {
        this.FriendSendReq.splice(_.findIndex(this.FriendSendReq, function (o) { return o.tokenuser === data.tokenuser }), 1)
      }
    },
    updatecreategroup (data, filename) {
      if (_.find(this.listgroup, function (o) { return o.group_id === data.group_id }) === undefined) {
        this.listgroup.unshift({
          count_read: '',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          picture: filename,
          state: data.state,
          timestamp: data.timestamp,
          tokenroom: data.tokenroom,
          type: data.type
        })
        this.listgroup = _.orderBy(this.listgroup, ['name'], ['asc'])
      }
    },
    updatelistchat (data, filename) {
      // console.log('data')
      if (_.find(this.listchat, function (o) { return o.group_id === data.group_id }) === undefined) {
        this.listchat.unshift({
          count_read: '',
          create_date: data.create_date,
          group_id: data.group_id,
          member: data.member,
          name: data.name,
          nickname: '',
          picture: filename,
          state: data.state,
          timestamp: data.create_date,
          tokenroom: data.tokenroom,
          type: data.type
        })
      }
    },
    toTab (tab) {
      if (tab === 1) {
        this.tabs = 'tab-1'
        // console.log(this.tabs)
      } else if (tab === 2) {
        this.tabs = 'tab-2'
        // console.log(this.tabs)
      } else if (tab === 3) {
        this.tabs = 'tab-3'
        // console.log(this.tabs)
      }
    },
    toPage (data) {
      this.$router.push(data)
    },
    time (timestamp) {
      if (this.$i18n.locale == 'th') {
        return Momenttime.momenttimethaiformnow(timestamp)
      } else if (this.$i18n.locale == 'cn') {
        return Momenttime.momenttimethaiformnowcn(timestamp)
      } else {
        return Momenttime.momenttimethaiformnowen(timestamp)
      }
      // return Momenttime.momenttimethaiformnow(timestamp)
    },
    routeChat (data) {
      // console.log(data.tokenroom)
      this.actionF = data.tokenroom
      this.$router.push('/mobile/room/' + data.tokenroom)
      this.$emit('data', true)
      var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      this.listchat[indexmsg].is_active = 'true'
      this.listchat[indexmsg].count_read = 0
      this.mark_read(data)
    },
    mark_read (data) {
      // console.log(data)
      if (data.count_read !== '0' && data.count_read !== '') {
        this.axios.post(process.env.APIalpine + '/api/v1/user-mark-read', {tokenuser: this.tokenuser, tokenroom: data.tokenroom}).then((response) => {
          // console.log(response.data)
        })
      }
    },
    getlistfriend () {
      this.ProgressListFriend = true
      this.axios.post(process.env.APIgo_api + '/v1/get-list-friend', {tokenuser: this.tokenuser}).then((response) => {
        if (response.data.status === 'success') {
          this.ProgressListFriend = false
          this.listfriend = response.data['list_friend']
          // console.log(this.listfriend)
        } else {
          this.ProgressListFriend = false
        }
      })
    },
    getlistgroup () {
      this.ProgressListGroup = true
      this.axios.post(process.env.APIgo_api + '/v1/get-list-group', {tokenuser: this.tokenuser}).then((response) => {
        if (response.data.status === 'success') {
          this.ProgressListGroup = false
          this.listgroup = response.data['list_active_group']
        } else {
          this.ProgressListGroup = false
        }
      })
    },
    getlistchat () {
      this.ProgressListChat = true
      this.axios.post(process.env.APInew_listchat, {tokenuser: this.tokenuser}).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.ProgressListChat = false
          this.listchat = response.data['listchat']
          // pinchat
          var listpin = []
          var linstunpin = []
          this.listchat = _.partition(this.listchat, function(o) { return o.pin == 'true'})
          listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
          linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
          this.listchat = _.union(listpin, linstunpin)
          // num_countread
          var indexblock = []
          var indexmessage = []
          var indexactive = []
          indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
          indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
          indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
          var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
          var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
          var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
          var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
          this.num_countread = count - ( countblock + countmsg + countactive)
          if (this.num_countread > 0) {
            this.showcountread = true
          } else {
            this.showcountread = false
          }
        } else {
          this.ProgressListChat = false
        }
        // check consent onechat
        // เปลี่ยนไปเช็คที่ layout แทน
        // this.check_consent(this.tokenuser)
      })
    },
    closeDialogConsentOnechat (value) {
      this.consentOnechatDialog = value
    },
    check_consent (token) {
      var today = new Date()
      var dd = String(today.getDate()).padStart(2, '0')
      var hour = String(today.getHours() + 1).padStart(2, '0')
      var minute = String(today.getMinutes()).padStart(2, '0')
      var seconds = String(today.getSeconds()).padStart(2, '0')
      var milsec = today.getMilliseconds()
      var mm = String(today.getMonth() + 1).padStart(2, '0')
      var yyyy = today.getFullYear()
      // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
      if (hour === '24') {
        hour = '00'
        dd = String(today.getDate() + 1).padStart(2, '0')
        var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
        // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
        if (parseInt(dd) === date_of_month) {
          // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
          dd = '1'
          // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
          if (mm === '12') {
            // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
            mm = '1'
            yyyy = today.getFullYear() + 1
          } else {
            // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
            mm = String(today.getMonth() + 2).padStart(2, '0')
            // console.log(mm)
          }
        }
      }
      today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
      // console.log(today)
      var expireddate = Date.parse(today)
      // console.log(expireddate)
      var body = Encode.encodeRichmenu({ 'userid': token, 'expired_date': expireddate })
      // console.log(body)
      this.axios.post(process.env.APIgo_api + `/v1/get-consent`, { onechat_token: body }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          if (response.data.data.consent_check === 'false') {
            this.consentOnechatDialog = true
            this.url_consent = response.data.data.consent_url
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    lengthactive (member, key) {
      var num = 0
      for (var i = 0; i < member.length; i += 1) {
        if (member[i][key] === 'active') {
          num = num + 1
        }
      }
      return num
    },
    showUserInGroup (item) {
      // console.log(item)
      this.showgroup = item
      this.showDialog('ShowFriend')
    },
    showDialog (dialog) {
      if (dialog === 'ShowFriend') {
        this.ShowFriend = true
      }
    },
    closeDialogShowFriend (value) {
      this.ShowFriend = value
    },
    findWithAttr (array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-btn--floating.v-btn--small {
  height: 30px !important;
  width: 30px !important;
}
/* .scrolling-wrapper {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  max-width: 100% !important;
  display: -webkit-inline-box !important;
  width: 100% !important;
} */
.scrolling-wrapper-setting {
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.scrolling-wrapper-setting::-webkit-scrollbar {
  height: 4px !important;
  width: 4px !important;
}
.scrolling-wrapper-setting::-webkit-scrollbar-thumb {
  border-radius: 8px !important;
  background: rgba(0, 0, 0, .1) !important;
}

.scrolling-wrapper {
  display: flex;
  overflow-x: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 10px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
>>>.v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: none !important;
}
.text2 {
  white-space: nowrap;
  width: 35vw;
  overflow: hidden;
  text-overflow: ellipsis;
}
.text-transform {
  text-transform: none;
}
.leftbox {
  /* height: calc(100vh - 64px); */
  background-color: #fff !important;
  overflow: hidden;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.fontselect {
  color: #000 !important;
  font-family: 'CS ChatThaiUI' !important;
  font-size:13px;
}
.nonselectF {
  color: #000 !important;
  font-family: 'CS ChatThaiUI' !important;
  font-size:13px;
}
.backgroundlistchat {
  padding-left: 0px !important;
  padding-right: 0px !important;
  background-color: rgb(255, 255, 255) !important;
  width: 100% !important;
}
>>>.v-input__slot {
  border-width: thin !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-color: #808080a6 !important;
  box-shadow: none !important;
}
>>>.v-badge__badge {
  margin-right: 4px;
  margin-top: 8px;
  color: #fff;
  display: flex;
  position: absolute;
  font-size: 14px;
  top: -11px;
  right: -22px;
  border-radius: 50%;
  height: 22px;
  width: 22px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  transition: .3s cubic-bezier(.25,.8,.5,1);
}
>>>.theme--light.v-icon {
  color: rgb(37, 98, 175);
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/layout/LeftSideMobileTest.vue